<div class="grid">
  <div class="col-2"></div>
  <div class="col-8">
    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
      <div class="grid">
        <div class="flex col-12 page-title gap-2 mb-2">
          {{ 'SignUp.RequestAccount' | translate }}
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="firstName"
              aria-describedby="firstName-help"
              formControlName="firstName"
              class="w-full" />
            <label for="firstName">{{ 'SignUp.FirstName' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.firstName.invalid &&
            (signupForm.controls.firstName.dirty || signupForm.controls.firstName.touched)
          ) {
            <div>
              @if (signupForm.controls.firstName.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.FirstNameRequired' | translate }}" />
              }

              @if (signupForm.controls.firstName.hasError('maxLengthExceeded')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.ExceedTestLimit' | translate }}" />
              }

              @if (signupForm.controls.firstName.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.MinCharacters' | translate }}" />
              }

              @if (signupForm.controls.firstName.hasError('invalidTextInput')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowCharecter' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="lastName"
              aria-describedby="lastName-help"
              formControlName="lastName"
              class="w-full" />
            <label for="lastName">{{ 'SignUp.LastName' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.lastName.invalid &&
            (signupForm.controls.lastName.dirty || signupForm.controls.lastName.touched)
          ) {
            <div>
              @if (signupForm.controls.lastName.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.LastNameRequired' | translate }}" />
              }

              @if (signupForm.controls.lastName.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.MinCharacters' | translate }}" />
              }

              @if (signupForm.controls.lastName.hasError('maxLengthExceeded')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.ExceedTestLimit' | translate }}" />
              }

              @if (signupForm.controls.lastName.hasError('invalidTextInput')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowCharecter' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-12 mb-2">
          <p-floatlabel>
            <input pInputText id="email" aria-describedby="email-help" formControlName="email" class="w-full" />
            <label for="email">{{ 'SignUp.EmailAddress' | translate }} *</label>
          </p-floatlabel>
          @if (signupForm.controls.email.touched && signupForm.controls.email.hasError('required')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.EmailAddressRequired' | translate }}" />
          }

          @if (signupForm.controls.email.touched && signupForm.controls.email.hasError('pattern')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.InvalidEmail' | translate }}" />
          }
        </div>
        <div class="col-12 mb-2">
          <app-custom-password class="custom-component"
            formControlName="password"
            floatLabel="{{ 'Auth.Password' | translate }} *" />
          @if (signupForm.controls.password.touched && signupForm.controls.password.hasError('required')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.PasswordRequired' | translate }}" />
          }

          @if (signupForm.controls.password.touched && signupForm.controls.password.hasError('pattern')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Auth.UnmetCriteria' | translate }}" />
          }
        </div>
        <div class="col-12 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="workAddress"
              aria-describedby="workAddress-help"
              formControlName="workAddress"
              class="w-full" />
            <label for="workAddress">{{ 'SignUp.WorkAddress' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.workAddress.invalid &&
            (signupForm.controls.workAddress.dirty || signupForm.controls.workAddress.touched)
          ) {
            <div>
              @if (signupForm.controls.workAddress.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.WorkAddressRequired' | translate }}" />
              }

              @if (signupForm.controls.workAddress.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.MaxMinCharacters' | translate }}" />
              }

              @if (
                signupForm.controls.workAddress.hasError('invalidAlphanumericWithSpecialCharactersAndDiacriticsInput')
              ) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowAlphaNumericDiacritics' | translate }}" />
              }
            </div>
          }
        </div>

        <div class="col-6 mb-2">
          <p-floatlabel>
            <p-select id="country"
              class="w-full"
              [options]="(countries$ | async) ?? []"
              formControlName="country"
              optionLabel="name"
              aria-describedby="country-help"
              inputId="country"
              (onChange)="onChangeCountry()" />
            <label for="country">{{ 'SignUp.Country' | translate }} *</label>
          </p-floatlabel>
          @if (signupForm.controls.country.touched && signupForm.controls.country.hasError('required')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.CountryRequired' | translate }}" />
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <p-select id="county"
              class="w-full"
              [options]="(regions$ | async) ?? []"
              formControlName="county"
              optionLabel="name"
              aria-describedby="county-help"
              (onChange)="onChangeRegion()"
              inputId="county" />
            <label for="county">{{ 'SignUp.County' | translate }} *</label>
          </p-floatlabel>
          @if (signupForm.controls.county.touched && signupForm.controls.county.hasError('required')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.CountyRequired' | translate }}" />
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <input pInputText id="zipcode" aria-describedby="zipcode-help" formControlName="zipcode" class="w-full" />
            <label for="zipcode">{{ 'SignUp.Zipcode' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.zipcode.invalid &&
            (signupForm.controls.zipcode.dirty || signupForm.controls.zipcode.touched)
          ) {
            <div>
              @if (signupForm.controls.zipcode.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.ZipcodeRequired' | translate }}" />
              }

              @if (signupForm.controls.zipcode.hasError('invalidAlphanumericInput')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowAlphanumeric' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <p-select id="city"
              class="w-full"
              [options]="(cities$ | async) ?? []"
              [filter]="true"
              filterBy="name"
              [showClear]="false"
              formControlName="city"
              optionLabel="name"
              aria-describedby="city-help"
              inputId="city" />
            <label for="city">{{ 'SignUp.City' | translate }} *</label>
          </p-floatlabel>
          @if (signupForm.controls.city.touched && signupForm.controls.city.hasError('required')) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.CityRequired' | translate }}" />
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <p-select id="countryCode"
              class="w-full"
              [options]="(countries$ | async) ?? []"
              formControlName="countryCode"
              optionLabel="phoneNumberPrefixWithPlus"
              optionValue="phoneNumberPrefix"
              aria-describedby="countryCode-help"
              inputId="countryCode" />
            <label for="countryCode">{{ 'Order_Info.CountryCode' | translate }}</label>
          </p-floatlabel>
          @if (
            signupForm.hasError('countryCodeRequired') &&
            (signupForm.controls.phoneNumber.dirty || signupForm.controls.phoneNumber.touched)
          ) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Order_Info.CountryCodeIsRequired' | translate }}" />
          }
        </div>
        <div class="col-6 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="phoneNumber"
              aria-describedby="phoneNumber-help"
              formControlName="phoneNumber"
              class="w-full" />
            <label for="phoneNumber">{{ 'OrderDetails.Phone' | translate }}</label>
          </p-floatlabel>
          @if (
            signupForm.controls.phoneNumber.invalid &&
            (signupForm.controls.phoneNumber.dirty || signupForm.controls.phoneNumber.touched)
          ) {
            <div>
              @if (signupForm.controls.phoneNumber.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'Order_Info.Phone_Number_Only' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-12 mb-2">
          <p-floatlabel>
            <p-select id="medicalSpecialty"
              class="w-full"
              [options]="(medicalSpecialties$ | async) ?? []"
              formControlName="medicalSpecialty"
              optionLabel="name"
              aria-describedby="medicalSpecialty-help"
              inputId="medicalSpecialty" />
            <label for="medicalSpecialty">{{ 'SignUp.MedicalSpecialty' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.medicalSpecialty.touched && signupForm.controls.medicalSpecialty.hasError('required')
          ) {
            <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'SignUp.MedicalSpecialtyRequired' | translate }}" />
          }
        </div>
        <div class="col-12 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="doctorId"
              aria-describedby="doctorId-help"
              formControlName="doctorId"
              class="w-full" />
            <label for="doctorId">{{ 'SignUp.DoctorID' | translate }}</label>
          </p-floatlabel>
          @if (
            signupForm.controls.doctorId.invalid &&
            (signupForm.controls.doctorId.dirty || signupForm.controls.doctorId.touched)
          ) {
            <div>
              @if (signupForm.controls.doctorId.hasError('invalidDigitCharacterInput')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowDigitChar' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-12 mb-2">
          <p-floatlabel>
            <input
              pInputText
              id="instituteName"
              aria-describedby="instituteName-help"
              formControlName="instituteName"
              class="w-full" />
            <label for="instituteName">{{ 'SignUp.InstituteName' | translate }} *</label>
          </p-floatlabel>
          @if (
            signupForm.controls.instituteName.invalid &&
            (signupForm.controls.instituteName.dirty || signupForm.controls.instituteName.touched)
          ) {
            <div>
              @if (signupForm.controls.instituteName.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.InstituteNameRequired' | translate }}" />
              }

              @if (signupForm.controls.instituteName.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.AllowAlphaNumericDiacritics' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-12 mb-2">
          <p-checkbox formControlName="isQualifiedProfessional"
            [binary]="true"
            inputId="isQualifiedProfessional"
            class="pb-2" />
          <label for="isQualifiedProfessional" class="ml-2">{{ 'SignUp.IamHealthcare' | translate }} *</label>
          @if (
            signupForm.controls.isQualifiedProfessional.invalid &&
            (signupForm.controls.isQualifiedProfessional.dirty || signupForm.controls.isQualifiedProfessional.touched)
          ) {
            <div>
              @if (signupForm.controls.isQualifiedProfessional.hasError('required')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.isQualifiedProfessionalRequired' | translate }}" />
              }
            </div>
          }
        </div>
        <div class="col-12 mb-2">
          <span class="ml-2">{{ 'NIPT.clinicalHistory.common.marksMandatoryFields.Label' | translate }}</span>
        </div>
        <div class="col-12 mb-2">
          @if (accountRequestStatus$ | async; as state) {
            <p-button [label]="'SignUp.Submit' | translate"
              type="submit"
              [disabled]="!signupForm.valid"
              styleClass="p-button-rounded w-full"
              [loading]="state === actionStatus.Pending"
              class="p-2" />
          }
        </div>
        <div class="col-12 term-condition mb-2">
          <div class="w-full">
            <span [innerHTML]="'SignUp.Note_1' | translate"></span>
          </div>
          <br />
          <div class="w-full">
            <span [innerHTML]="'SignUp.Note_2' | translate"></span>
          </div>
          <br />
          <div class="w-full">
            <span [innerHTML]="'SignUp.Note_3' | translate"></span>
          </div>
        </div>
        <div class="col-12">
          <div class="col-3 p-0 col-offset-5">
            <app-language-selector />
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-2"></div>
</div>
